import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Heading, Spacer, Text, Flex, TextButton } from "@badi/badi-components";
import { translate } from "base/shared/Localization";
import { getLanguagesString, getOccupationString } from "base/shared/User";
import {
  enquiryUserPictureClick,
  enquiryProfileInfoClick,
} from "datamodel/Conversation/tracking-events";
import { openOtherUserProfileModal } from "components/other-user-profile-modal";
import Slider from "components/slider-new";
import { ImageWrapper } from "./styled-components";

const UserInfo = ({
  id,
  pictures,
  name,
  age,
  languages,
  occupation,
  token,
}) => {
  const sliderPictures = useMemo(
    () => ({
      urls: pictures.map(({ width_500_url: url }) => url),
      total: pictures.length,
    }),
    [pictures],
  );
  const handleProfileClick = () => {
    enquiryProfileInfoClick();
    openOtherUserProfileModal(token, id);
  };

  const handlePictureClick = () => {
    enquiryUserPictureClick();
    openOtherUserProfileModal(token, id);
  };

  return (
    <Flex direction="column" gutter={3} lg={{ direction: "row", gutter: 3 }}>
      <ImageWrapper>
        <Slider
          dataQa="user-picture-slider"
          onClick={handlePictureClick}
          pictures={sliderPictures}
          type="user"
        />
      </ImageWrapper>
      <Flex direction="column">
        <Heading data-qa="enquiry-seeker-name" level="16-Bold">
          {name}, {age}
        </Heading>
        <Text body="14-Regular" dataQa="enquiry-seeker-occupation">
          {getOccupationString(occupation)}
        </Text>
        <Text body="12-Regular" dataQa="enquiry-seeker-languages">
          {getLanguagesString(languages)}
        </Text>
        <Spacer top={2}>
          <TextButton
            data-qa="enquiry-seeker-button"
            onClick={handleProfileClick}
            small={false}
          >
            {translate("lister.contact.request.cta_view.full.profile")}
          </TextButton>
        </Spacer>
      </Flex>
    </Flex>
  );
};

UserInfo.propTypes = {
  age: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  name: PropTypes.string.isRequired,
  occupation: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  pictures: PropTypes.arrayOf(
    PropTypes.shape({
      width_500_url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  token: PropTypes.string.isRequired,
};

export default UserInfo;
